import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_CustomTextInput = _resolveComponent("CustomTextInput")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_TabProgression = _resolveComponent("TabProgression")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "ma-n2 header" }, {
    default: _withCtx(() => [
      (_ctx.prevButton)
        ? (_openBlock(), _createBlock(_component_CustomButton, {
            key: 0,
            class: "ml-2 my-auto",
            level: _ctx.$enums.ButtonLevels.SmallIcon,
            icon: "caret-left",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('prev')))
          }, null, 8, ["level"]))
        : _createCommentVNode("", true),
      (_ctx.header !== undefined)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.headerEditable)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_CustomTextInput, {
                    modelValue: _ctx.internalHeader,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.internalHeader) = $event)),
                    ref: "headerInput",
                    plain: true,
                    max: 30,
                    class: _normalizeClass([_ctx.editingHeader ? '' : 'pointer-events-none', "mr-0"]),
                    disabled: _ctx.headerEditLoading,
                    forcedFocus: _ctx.editingHeader,
                    style: {"width":"calc(100% - 74px)"},
                    onKeyup: _withKeys(_ctx.saveHeader, ["enter"])
                  }, null, 8, ["modelValue", "class", "disabled", "forcedFocus", "onKeyup"]),
                  _createVNode(_component_CustomButton, {
                    class: "ml-auto mr-2 my-auto",
                    level: _ctx.$enums.ButtonLevels.SmallIcon,
                    icon: 
            _ctx.editingHeader ? 'save' : _ctx.headerEditLoading ? 'spinner' : 'edit'
          ,
                    disabled: _ctx.headerEditableDisabled || _ctx.headerEditLoading,
                    onClick: _cache[2] || (_cache[2] = 
            () => {
              if (!_ctx.editingHeader) _ctx.startEditingHeader();
              else _ctx.saveHeader();
            }
          )
                  }, null, 8, ["level", "icon", "disabled"])
                ], 64))
              : (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  class: "pa-0 token-text-regular ml-3 my-auto"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.header), 1)
                  ]),
                  _: 1
                }))
          ], 64))
        : (_ctx.displayProgression)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 2,
              class: "progression-col pa-0 ma-auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TabProgression, {
                  stage: _ctx.progression,
                  maxStage: _ctx.maxProgression
                }, null, 8, ["stage", "maxStage"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
      (_ctx.closeButton)
        ? (_openBlock(), _createBlock(_component_CustomButton, {
            key: 3,
            class: "ml-auto mr-2 my-auto",
            level: _ctx.$enums.ButtonLevels.SmallIcon,
            icon: "x",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
          }, null, 8, ["level"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}